import React, { PropTypes } from 'react';
import SelectItemModal from 'template/Modals/SelectItem';
import getCurrentTeacher from 'controllers/teacher/getCurrentTeacher'
import Teacher from 'mediators/Teacher';

//
// User can select a teacher within a class
// a wraper of SelectItemModal
//
// eg.
// SelectClassTeacher({ classId })
//  .then()
//  .catch()
//
export default function(opts) {

  const { 
    schoolId, 
    conflictedIDs, 
    selectMultiple,
    amount_per_page = 25,
  } = opts;

  // this will return a promise
  return SelectItemModal({
    headerTitle: __('Select Teacher', 'schedule'),
    headerIcon: 'fa icon-chalkboard-teacher',
    itemName: __('Teacher', 'schedule'),
    searchPlaceholder: __('Search Teacher', 'schedule'),
    selectMultiple: selectMultiple,
    showName: true,
    backendSearch: true,
    getItemLabel: (teacher)=>{
      return teacher.name;
    },
    fetchItems: (cb, fetchOpts)=>{
      const {
        searchKeyword,
        currentPageNumber,
      } = fetchOpts;

      getCurrentTeacher({
        schoolId,
        current_page_number: currentPageNumber,
        keyword: searchKeyword,
        amount_per_page,
      })
        .then((data)=>{
          const { 
            list,
            page_amount,
          } = data;
          
          const pageMeta = {
            maxPageNumber: page_amount,
          };
          
          const teacherObjs = list.map((raw)=>{
            return new Teacher(raw);
          });

          cb(teacherObjs, pageMeta);
        })
        .catch((err)=>{ console.error(err); });
    },
    components: {
      SelectItem: ({item, getItemLabel, selected, onClickSelect, selectText, selectedText, mixin}) => {

        const conflicted = conflictedIDs.indexOf(item.id) > -1;

        return (
          <div className='select-item' >
            <div>
              { item.name }
            </div>
            <div className='select-button'>
              { conflicted && <span style={{ color: 'red' }}>{__('Conflict', 'classdetail')}</span> }
              { selected && <span className='btn-link currently-selected' onClick={onClickSelect}>{selectText || __('Selected', 'SelectItemModal')}</span>}
              { !selected && <span className='btn-link' onClick={onClickSelect}>{selectedText || __('Select', 'SelectItemModal')}</span>}
            </div>
          </div>
         );
      }
    },
    selectFilter: (item, alreadySelected, selected)=>{
      return alreadySelected.id == item.id;
    },

    selected: opts.selected,

    ...opts,

  })
}



// WEBPACK FOOTER //
// ./src/template/Modals/SelectClassTeacher/index.js